$(() => {
    $('.js-banner-slider').slick({
        dots: true,
        autoplay: true,
        responsive: [
            {
                breakpoint: 767,
                settings: 'unslick'
            }
        ]
    });
});


// WEBPACK FOOTER //
// ./markup/components/main/banner/banner.js